module.exports = __webpack_public_path__ + "static/media/save-icon.fa8ae8bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/save-icon.svg
// module id = 1973
// module chunks = 0